import React, { Component } from "react";
import {
  TextField,
  InputAdornment,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Icon,
} from "@material-ui/core";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactTableComponent from "../../ReactTable/ReactTable";
import { sitesList } from "./SiteConfig";
import {
  siteListQuery,
  addSiteQuery,
  siteCityData,
  siteCountry,
  siteUserdata,
  siteListDropDownData,
} from "./SiteQuery";
import SearchIcon from "@material-ui/icons/Search";
import { fetchMethod, debounce } from "../../FetchMethod";
import { connect } from "react-redux";
import "./sites.css";
import store from "../../Redux/Store";
import { FadeLoader } from "react-spinners";
import { mutationQueries } from "../../MutationMethod";
import SnackBarComponent from "../../SnackBar/SnackBar";

const iconComponent = (props) => {
  return (
    <Icon className={props.className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.992"
        height="8"
        viewBox="0 0 13.992 8"
        style={{
          fill: "#69BAFE",
          // width: "23px",
          height: "auto",
        }}
      >
        <defs></defs>
        <path
          className="a"
          d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
          transform="translate(-6.188 -11.246)"
        />
      </svg>
    </Icon>
  );
};
class Sites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: parseInt(localStorage.getItem("rows")),
      rows: parseInt(localStorage.getItem("rows")),
      listData: undefined,
      count: 0,
      isAscSort: true,
      StatusData: [
        {
          id: "",
          name: "",
        },
        {
          id: "PENDINGCONDITIONALAPPROVED",
          name: "Pending Conditional Approval",
        },
        { id: "CONDITIONALLYAPPROVED", name: "Conditionally Approved" },
        { id: "APPROVEDTOTREAT", name: "Approved to Treat" },
        { id: "INDEPENDENT", name: "Independent" },
      ],
      filter: { active: 1, order: "createdon DESC" },
      countryData: undefined,
      countryid: null,
      cityid: null,
      cityData: undefined,
      salesRepData: undefined,
      deletemodalOpen: false,
      approvalstatus: "",
      search: "",
      isRolePermission: store.getState().Permission
        ? store.getState().Permission.USER_SITE_FILE_PERMISSION
        : false,
      loading: true,
      deleteid: 0,
      open: false,
      severity: "",
      alertmsg: "",
      siteUserdata: [],
      site: "",
    };
  }
  UNSAFE_componentWillMount() {
    this.setState({ listData: [] });
    this.props.sideBarPath("/sites");
    this.getlistData();
    this.dropDowndata();
  }
  LinkClicked = (e, data) => {
    const { id } = e.target;
    let { listData } = this.state;
    listData.map((siteitems) => {
      if (siteitems.id === data.id) {
        if (id === "physicians") {
          siteitems.physician = siteitems.fullphysicianlist;
          siteitems.physicianclicked = true;
        } else if (id === "assistance") {
          siteitems.assistance = siteitems.fullassistantlist;
          siteitems.assistantclicked = true;
        } else {
          siteitems.salesRep = siteitems.fullsalesreplist;
          siteitems.salesrepclicked = true;
        }
        return siteitems;
      }
    });
    this.setState({ listData });
  };
  getlistData = () => {
    this.setState({ loading: true, listData: [] });
    fetchMethod(siteListQuery, {
      where: this.state.filter,
      last: this.state.rows,
      first: this.state.pageNo,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        if (res.data.allSites.Sites) {
          let data = res.data.allSites.Sites;

          data.map((item) => {
            let physiciancount = 0,
              assistantcount = 0,
              salesrepcount = 0,
              physician = "",
              assistance = "",
              salesRep = "";
            let fullphysicianlist = "",
              fullassistantlist = "",
              fullsalesreplist = "";
            if (item.mappedSite.Usersitemaps.length) {
              item.mappedSite.Usersitemaps.map((mappedUserItem) => {
                if (mappedUserItem.mappeduserrel.Userdata.length) {
                  mappedUserItem.mappeduserrel.Userdata.map((useritem) => {
                    if (useritem.role == "PHYSICIAN") {
                      physician = physician
                        ? physician
                        : `${useritem.firstname} ${useritem.lastname}`;
                      fullphysicianlist = `${
                        physiciancount ? fullphysicianlist + "," : ""
                      } ${useritem.firstname} ${useritem.lastname}`;
                      physiciancount += 1;
                    } else if (useritem.role === "ASSISTANT") {
                      assistance = assistance
                        ? assistance
                        : `${useritem.firstname} ${useritem.lastname}`;
                      fullassistantlist = `${
                        assistantcount ? fullassistantlist + "," : ""
                      } ${useritem.firstname} ${useritem.lastname}`;
                      assistantcount += 1;
                    } else if (
                      useritem.role === "SALES REP" ||
                      useritem.role === "SALESREP"
                    ) {
                      salesRep = salesRep
                        ? salesRep
                        : `${useritem.firstname} ${useritem.lastname}`;
                      fullsalesreplist = `${
                        salesrepcount ? fullsalesreplist + "," : ""
                      } ${useritem.firstname} ${useritem.lastname}`;
                      salesrepcount += 1;
                    }
                  });
                }
              });
            }
            Object.assign(item, {
              physiciancount: physiciancount
                ? physiciancount - 1
                : physiciancount,
              assistantcount: assistantcount
                ? assistantcount - 1
                : assistantcount,
              salesrepcount: salesrepcount ? salesrepcount - 1 : salesrepcount,
              assistance,
              salesRep,
              physician,
              LinkClicked: this.LinkClicked,
              fullphysicianlist,
              fullassistantlist,
              fullsalesreplist,
            });
            return (item["location"] =
              item.sitecityrel.Cities.length > 0 &&
              item.sitecountryrel.Countries.length > 0
                ? `${
                    item.sitecityrel.Cities.length > 0
                      ? item.sitecityrel.Cities[0].name
                      : ""
                  }, ${
                    item.sitecountryrel.Countries.length > 0
                      ? item.sitecountryrel.Countries[0].name
                      : ""
                  }`
                : item.sitecountryrel.Countries.length > 0
                ? `${
                    item.sitecountryrel.Countries.length > 0
                      ? item.sitecountryrel.Countries[0].name
                      : ""
                  }`
                : "");
          });
          this.setState({
            listData: data,
            count: res.data.allSites.totalCount,
            loading: false,
          });
        }
      })
      .catch((e) => {
        this.setState({ loading: false });
        console.log(e);
      });
  };
  dropDowndata = () => {
    fetchMethod(siteListDropDownData)
      .then((res) => res.json())
      .then((res) => {
        if (res.data) {
          this.setState({
            countryData: res.data.allCountries.Countries,
            // cityData: res.data.allCities.Cities,
            salesRepData: res.data.allUserdata.Userdata.map((item) => {
              item.name = `${item.firstname} ${item.lastname && item.lastname}`;
              return item;
            }),
            allCountryList:
              res.data.allCountries.Countries &&
              res.data.allCountries.Countries.map((countryItem) => {
                countryItem.cityList =
                  countryItem.StateCountry &&
                  countryItem.StateCountry.States &&
                  countryItem.StateCountry.States.map((stateItem) => {
                    let city =
                      stateItem.CityState &&
                      stateItem.CityState.Cities &&
                      stateItem.CityState.Cities.length &&
                      stateItem.CityState.Cities.map((cityItem) => {
                        return { id: cityItem.id, name: cityItem.name };
                      });
                    return city;
                  });
                countryItem.cityList = countryItem.cityList.flat();
                return countryItem;
              }),
            allSalesRepList: res.data.allUserdata.Userdata.map((item) => {
              item.name = `${item.firstname} ${item.lastname && item.lastname}`;
              return item;
            }),
          });
        }
      })
      .catch((e) => console.log(e));
  };
  debounceTimer = null;
  handleSearch = (e) => {
    const {
      target: { name, value },
    } = e;
    let { filter } = this.state;
    filter["and"] = [
      {
        or: [
          { siteid: { like: `%${value}%` } },
          { name: { like: `%${value}%` } },
        ],
      },
    ];
    this.setState({ [name]: value, filter, pageNo: this.state.rows }, () => {
      this.debounceTimer = debounce(
        this.debounceTimer,
        () => {
          this.getlistData();
        },
        200
      );
    });
  };
  handleSelect = (e) => {
    const {
      target: { name, value },
    } = e;
    let { filter } = this.state;
    filter[name] = value;
    this.setState({ [name]: value, filter, pageNo: this.state.rows }, () =>
      this.getlistData()
    );
  };
  handleSearchSelect = (name, value) => {
    let { filter } = this.state;
    value ? (filter[name] = value.id) : delete filter[name];
    if (name === "countryid") {
      let { countryData, allCountryList, cityList } = this.state;
      this.setState({ cityData: undefined });
      let PATTERN = RegExp(value ? value.name : "", "i");
      countryData = allCountryList.filter((item) => PATTERN.test(item.name));
      cityList = countryData.map((countryItem) => countryItem.cityList).flat()
        .length
        ? countryData.map((countryItem) => countryItem.cityList).flat()
        : [];
      this.setState({
        countryData,
        cityList,
        cityData: cityList,
        cityid: null,
      });
    }

    this.setState({ [name]: value, filter, pageNo: this.state.rows }, () =>
      this.getlistData()
    );
  };
  sortByHeader = (item) => {
    if (item === "siteid") {
      const { filter } = this.state;

      let { sortingParam, isAscSort } = this.state;

      if (this.state.isAscSort) {
        filter["order"] = "siteid DESC";
        sortingParam = "siteid";
        isAscSort = false;
      } else {
        sortingParam = item;
        filter["order"] = "siteid ASC";
        isAscSort = true;
      }

      this.setState(
        {
          filter,
          sortingParam,
          isAscSort,
        },
        () => this.getlistData()
      );
    }
  };
  updatePagination = (pageNumber, size) => {
    this.setState(
      {
        pageNo: pageNumber,
        rows: size,
      },
      () => {
        this.getlistData();
      }
    );
  };
  addsite = () => {
    this.props.history.push("/add-site");
  };
  handleClose = (id) => {
    this.setState((prevState) => {
      return { deletemodalOpen: !prevState.deletemodalOpen, deleteid: id };
    });
  };
  handleDelete = () => {
    const test = {
      id: this.state.deleteid,
      active: 0,
    };

    this.setState({ loading: true });
    mutationQueries(addSiteQuery, { obj: test })
      .then((res) => {
        this.setState({ loading: false });
        const id = res.data.saveSite.id;
        if (id) {
          let pageNo = this.state.pageNo;
          let previousData = this.state.listData.length;
          this.setState({
            listData: undefined,
            open: true,
            severity: "success",
            alertmsg: "Site deleted successfully",
          });

          const { filter } = this.state;

          let search = this.state.search;

          if (this.state.search !== "" && previousData === 1) {
            pageNo = this.state.rows;
            delete filter["and"];
            search = "";
          } else if (
            this.state.search === "" &&
            previousData === 1 &&
            pageNo !== this.state.rows
          ) {
            pageNo = this.state.pageNo - this.state.rows;
          } else {
            pageNo = this.state.pageNo;
          }

          this.setState(
            { pageNo, filter, search, deletemodalOpen: false, deleteid: 0 },
            () => this.getlistData()
          );
        }
      })
      .catch((e) => console.log(e));
  };
  editForm = (id) => {
    this.props.history.push({ pathname: "edit-site", state: { id: id } });
  };
  clearFilter = () => {
    this.setState(
      {
        search: "",
        approvalstatus: "",
        countryid: null,
        cityid: null,
        cityData: undefined,
        countryData: this.state.allCountryList,
        salesRepData: this.state.allSalesRepList,
        filter: { active: 1, order: "createdon DESC" },
        site: "",
      },
      () => this.getlistData()
    );
  };
  searchCity = (e) => {
    const {
      target: { value },
    } = e;
    let { cityData, cityList ,filter} = this.state;
    // debugger;
    if (value.length > 1) {
      let PATTERN = RegExp(value ? value : "", "i");
      cityData = cityList.filter((item) => PATTERN.test(item.name));
    } else {
      filter && filter.countryid && delete filter.cityid
      this.setState({ cityData: cityList ,filter},()=>this.getlistData());
    }
  };
  searchCountry = (e) => {
    const {
      target: { value },
    } = e;
    let { countryData, cityData, allCountryList, cityList ,filter} = this.state;
    if (value.length >= 1) {
      this.setState({ cityData: undefined });
      let PATTERN = RegExp(value ? value : "", "i");
      countryData = allCountryList.filter((item) => PATTERN.test(item.name));
      cityList = countryData.map((countryItem) => countryItem.cityList).flat()
        .length
        ? countryData.map((countryItem) => countryItem.cityList).flat()
        : [];
      this.setState({ countryData, cityList, cityData: cityList });
    } else {
      filter && filter.countryid && delete filter.countryid
      this.setState({ countryData: undefined, cityid: null ,filter , countryid:null},()=>this.getlistData());
      this.dropDowndata();
    }
  };
  handleSnackBarClose = () => {
    let { severity } = this.state;
    this.setState({ open: false, severity: "", alertmsg: "" });
  };
  handleSearchSalesSelect = (name, value) => {
    let { filter, allSalesRepList, salesRepData } = this.state;
    this.setState({ site: { name: value && value.name } });
    if (value && value.mappedUser) {
      // let PATTERN = RegExp(value ? value : "", "i");
      // salesRepData = allSalesRepList.filter((item) => PATTERN.test(item.name));
      let siteIdArray = [];
      if (value.mappedUser && value.mappedUser.Usersitemaps) {
        // debugger;
        if (value.mappedUser.Usersitemaps.length) {
          value.mappedUser.Usersitemaps.map((item) => {
            siteIdArray.push({ id: item.siteid });
            return { id: item.siteid };
          });
        }
        filter["and"] = [{ or: siteIdArray }];
        if (siteIdArray.length)
          this.setState({ filter, pageNo: this.state.rows }, () =>
            this.getlistData()
          );
        else this.setState({ listData: [], count: 0 });
      } else {
        this.setState({ listData: [], count: 0 });
      }
    } else {
      filter["and"] = [
        {
          or: [],
        },
      ];
      this.setState(
        { pageNo: this.state.rows, filter, salesRepData: allSalesRepList },
        () => this.getlistData()
      );
    }
  };
  searchSalesRep = (e) => {
    const {
      target: { value },
    } = e;
    let { allSalesRepList, salesRepData , filter } = this.state;
    this.setState({ site: { name: value } });
    if (value) {
      let PATTERN = RegExp(value ? value : "", "i");
      salesRepData = allSalesRepList.filter((item) => PATTERN.test(item.name));
      console.log(salesRepData, "Data");
      this.setState({ salesRepData });
    } else {
      filter && filter.and && delete filter.and
      this.setState({ salesRepData: allSalesRepList ,filter ,salesRep:null,site:null},()=>this.getlistData());
    }
  };
  render() {
    const nameAndImage = [
      {
        Header: () => {
          return (
            <div style={{ cursor: "pointer" }}>
              Site ID
              {this.state.isAscSort ? <ArrowUpward /> : <ArrowDownward />}
            </div>
          );
        },
        accessor: "siteid",
        width: 80,
      },
    ];

    const actions = [
      {
        Header: "Action",
        sortable: false,
        Cell: (row) => (
          <div className="actions">
            <IconButton
              className="editicon"
              onClick={() => this.editForm(row.original.id)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <defs></defs>
                <path
                  className="a"
                  d="M4.5,18.747V22.5H8.249L19.308,11.438,15.558,7.688ZM22.207,8.538a1,1,0,0,0,0-1.41l-2.34-2.34a1,1,0,0,0-1.41,0l-1.83,1.83,3.749,3.749Z"
                  transform="translate(-4.5 -4.496)"
                />
              </svg>
            </IconButton>
            <IconButton
              className="deleteicon"
              onClick={() => this.handleClose(row.original.id)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.75"
                height="18"
                viewBox="0 0 15.75 18"
              >
                <defs></defs>
                <path
                  className="a"
                  d="M15.187,1.125H10.969l-.33-.657A.844.844,0,0,0,9.882,0H5.864a.834.834,0,0,0-.752.468l-.33.657H.562A.562.562,0,0,0,0,1.687V2.812a.562.562,0,0,0,.562.562H15.187a.562.562,0,0,0,.562-.562V1.687A.562.562,0,0,0,15.187,1.125ZM1.87,16.418A1.687,1.687,0,0,0,3.554,18H12.2a1.687,1.687,0,0,0,1.684-1.582L14.625,4.5H1.125Z"
                />
              </svg>
            </IconButton>
          </div>
        ),
      },
    ];

    const columns = this.state.isRolePermission
      ? nameAndImage.concat(sitesList.columns).concat(actions)
      : nameAndImage.concat(sitesList.columns);
    return (
      <div className="Sites">
        {this.state.loading ? (
          <div className="Loader">
            <FadeLoader
              style={{ height: "15", width: "5", radius: "2" }}
              color={"#6FABF0"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          ""
        )}
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            timer={1000}
            handleClose={this.handleSnackBarClose}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
        <h1>Sites</h1>
        <div className="SiteFilterSection">
          <TextField
            variant="outlined"
            placeholder="By Site ID or Site Name"
            label="Search"
            name="search"
            autoComplete="off"
            value={this.state.search}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={this.handleSearch}
          />
          <Autocomplete
            name="countryId"
            freeSolo
            clearOnBlur
            value={this.state.countryid ? this.state.countryid : null}
            options={
              this.state.countryData !== undefined ? this.state.countryData : []
            }
            getOptionLabel={(option) => (option.name ? option.name : "")}
            onChange={(option, value) =>
              this.handleSearchSelect("countryid", value)
            }
            disableClearable
            forcePopupIcon={true}
            popupIcon={<svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.992"
                  height="8"
                  viewBox="0 0 13.992 8"
                  style={{ fill: "#69BAFE", marginRight: "5px" }}
                >
                  <defs></defs>
                  <path
                    className="a"
                    d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                    transform="translate(-6.188 -11.246)"
                  />
                </svg>}
              renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Country"
                onChange={(e) => this.searchCountry(e)}
                InputProps={{
                  ...params.InputProps,
                }}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "samlpetexttodisable", // disable autocomplete and autofill
                }}
              />
            )}
          />
          <Autocomplete
            name="cityid"
            freeSolo
            value={this.state.cityid ? this.state.cityid : null}
            options={
              this.state.cityData !== undefined ? this.state.cityData : []
            }
            getOptionLabel={(option) => (option.name ? option.name : "")}
            onChange={(option, value) =>
              this.handleSearchSelect("cityid", value)
            }
            disabled={!this.state.countryid}
            disableClearable
            forcePopupIcon={true}
            popupIcon={<svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.992"
                  height="8"
                  viewBox="0 0 13.992 8"
                  style={{ fill: "#69BAFE", marginRight: "5px" }}
                >
                  <defs></defs>
                  <path
                    className="a"
                    d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                    transform="translate(-6.188 -11.246)"
                  />
                </svg>}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="City"
                onChange={(e) => this.searchCity(e)}
                InputProps={{
                  ...params.InputProps,
                }}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "samlpetexttodisable", // disable autocomplete and autofill
                }}
              />
            )}
          />
          <Autocomplete
            name="country"
            value={this.state.salesRep !== undefined ? this.state.salesRep : ""}
            freeSolo
            options={
              this.state.salesRepData !== undefined
                ? this.state.salesRepData
                : []
            }
            getOptionLabel={(option) => (option.name ? option.name : "")}
            onChange={(option, value) =>
              this.handleSearchSalesSelect(option.name, value)
            }
            // onChange={(e) => this.handleSearchSalesSelect(e)}
            value={this.state.site}
            disableClearable
            forcePopupIcon={true}
            popupIcon={<svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.992"
                  height="8"
                  viewBox="0 0 13.992 8"
                  style={{ fill: "#69BAFE", marginRight: "5px" }}
                >
                  <defs></defs>
                  <path
                    className="a"
                    d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                    transform="translate(-6.188 -11.246)"
                  />
                </svg>}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Sales Rep"
                onChange={(e) => this.searchSalesRep(e)}
                InputProps={{
                  ...params.InputProps,
                }}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "samlpetexttodisable", // disable autocomplete and autofill
                }}
              />
            )}
          />
          <TextField
            className="siteStatusField"
            labelid="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            variant="outlined"
            select
            SelectProps={{
              IconComponent: iconComponent,
            }}
            value={this.state.approvalstatus}
            onChange={this.handleSelect}
            label="Status"
            name="approvalstatus"
          >
            {this.state.StatusData.map((item, index) => {
              return (
                <MenuItem key={index} value={item.id}>
                  {item.name}
                </MenuItem>
                //   <option key={index} value={item.id} style={{display:item.id ?'block':'none'}}>
                //   {item.name}
                // </option>
              );
            })}
          </TextField>

          {this.state.search ||
          this.state.approvalstatus ||
          this.state.countryid ||
          this.state.cityid ||
          this.state.site ? (
            <Button className="resetBtn" onClick={this.clearFilter}>
              Reset
            </Button>
          ) : (
            ""
          )}
          {this.state.isRolePermission ? (
            <Button className="addsiteBtn" onClick={this.addsite}>
              Add Site
            </Button>
          ) : (
            ""
          )}
        </div>

        <div className="SitesTableSection">
          {this.state.listData ? (
            <ReactTableComponent
              listData={this.state.listData}
              listConfig={sitesList}
              columns={columns}
              dataCount={this.state.count}
              onHeaderClick={this.sortByHeader}
              updatePagination={this.updatePagination}
              initialPage={this.state.pageNo / this.state.rows}
              forSerialNo={{
                pageNo: this.state.pageNo,
                pageSize: this.state.rows,
              }}
            />
          ) : (
            ""
          )}
        </div>
        <Dialog
          open={this.state.deletemodalOpen}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Confirm</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={this.handleClose} className="cancelbtn">
              Cancel
            </Button>
            <Button
              onClick={this.handleDelete}
              autoFocus
              className="confirmbtn"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    sideBarPath: (route) =>
      dispatch({ type: "Show_Sidebar_Route", payload: route }),
  };
};

export default connect(null, mapDispatchToProps)(Sites);
